import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=f2652a3c&scoped=true"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=f2652a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2652a3c",
  null
  
)

export default component.exports